export default __webpack_public_path__ + "static/media/AMPLIUS-FAST.b7de56c8.png";